import PropTypes from 'prop-types';
import React from 'react';

import styles from './language-selector.css';

const SUPPORTED_LOCALES = {
    'en': {name: 'English'},
    'fr': {name: 'Français'}
};

const LanguageSelector = ({currentLocale, label, onChange}) => (
    <select
        aria-label={label}
        className={styles.languageSelect}
        value={currentLocale}
        onChange={onChange}
    >
        {
            Object.keys(SUPPORTED_LOCALES).map(locale => (
                <option
                    key={locale}
                    value={locale}
                >
                    {SUPPORTED_LOCALES[locale].name}
                </option>
            ))
        }
    </select>
);

LanguageSelector.propTypes = {
    currentLocale: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func
};

export default LanguageSelector;
